"use client"

import "swiper/css"
import "swiper/css/pagination"
import { Autoplay, Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"
import "./eventCarousel.css"

import { getFixedT } from "@/languages/i18n"
import type { EventItem } from "../types"
import { EventSkeleton } from "./EventSkeleton"
import { EventSlide } from "./EventSlide"

interface EventCarouselProps {
  events: EventItem[]
  loading: boolean
  className?: string
  locale?: string
}

export const EventCarousel = ({ events, loading, className = "", locale }: EventCarouselProps) => {
  const t = getFixedT(locale)
  if (loading) {
    return (
      <div className={`event-carousel-container ${className}`}>
        <EventSkeleton />
      </div>
    )
  }

  if (events.length === 0) {
    return (
      <div className={`event-carousel-container ${className}`}>
        <p className="text-center py-8 text-base leading-[200px] text-[#333333]">{t("No results found.")}</p>
        <p className="bg-[#19b04e] h-[5px] w-10 rounded-full mx-auto"></p>
      </div>
    )
  }

  return (
    <div className={`event-carousel-container ${className}`}>
      <Swiper
        modules={[Pagination, Autoplay]}
        loop={events.length > 1}
        autoplay={
          events.length > 1
            ? {
              delay: 5000,
              disableOnInteraction: false,
            }
            : false
        }
        pagination={{ clickable: true }}
        className="event-carousel-swiper w-full h-full"
      >
        {events.map((event) => (
          <SwiperSlide key={event.id} className="h-full">
            <EventSlide event={event} locale={locale} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}
